import React from 'react'
import { useTranslation } from 'react-i18next'
import { QuickGlanceOverlay, List, ListItem } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'

const AddEventOptionsOverlay = ({ addEventOptionsOverlay }) => {
  const [t] = useTranslation()

  const { openOverlay } = useOverlayContext()
  return (
    <QuickGlanceOverlay {...addEventOptionsOverlay}>
      <List>
        <ListItem
          onClick={() => {
            openOverlay('eventPanel')
            trackEvent({
              event_name: 'click_action',
              link_name: `Edit: Events: Open`,
            })
          }}
          primaryText={t('view-index.add-a-new-event.btn', 'Add a new event')}
          data-testid="add--new-event-button"
        />
        <ListItem
          onClick={() => {
            trackEvent({
              event_name: 'click_action',
              link_name: `Link Existing Event: Open`,
            })
            openOverlay('linkExistingEvent')
          }}
          primaryText={t('view-index.link-an-existing-event.btn', 'Link to an existing event')}
          data-testid="link--new-event-button"
        />
      </List>
    </QuickGlanceOverlay>
  )
}
export default AddEventOptionsOverlay
